import "../../../styles/demirbas.css";
import { uiState } from "../../state/uiState.js";
import {
	initDemirbasFilters,
	resetDemirbasFilters,
	destroyDemirbasFilterAmountInputs,
} from "./demirbasFilters.js";
import { clearDemirbasGrid, initDemirbasGridEvents, renderDemirbasGrid } from "./demirbasGrid.js";
import { initCreateDialog } from "./dialogs/create/createDialog.js";
import { initOverviewDialog } from "./dialogs/overviewDialog.js";
import { initEditDialog } from "./dialogs/editDialog.js";
import { isScannerRunning, startScanner, stopScanner } from "./barcodeScanner.js";
import { canUseBarcodeCart } from "./barcodeCartPermissions.js";
import {
	initBarcodeCartDialog,
	updateBarcodeCartUi,
	closeBarcodeCartDialog,
	resetDemirbasBarcodeCart,
} from "./dialogs/barcodeCartDialog.js";

let initialized = false;

function buildBarcodeSearchUrl(barcodeValue) {
	const params = new URLSearchParams();
	params.set("barkod", barcodeValue);
	return `/api/demirbas?${params.toString()}`;
}

function hideBarcodeScannerPanel(section) {
	const panel = section?.querySelector(".barcode-scanner-panel");
	const preview = section?.querySelector(".barcode-scanner-preview");
	const button = section?.querySelector(".barcode-camera-btn");

	stopScanner();

	if (preview) preview.innerHTML = "";
	if (panel) panel.hidden = true;
	button?.classList.remove("barcode-camera-btn--active");
}

function resetBarcodeModeState(section) {
	const input = section?.querySelector(".barcode-search-input");
	uiState.demirbas.barcodeQuery = "";
	if (input) input.value = "";
	hideBarcodeScannerPanel(section);
}

function resetDemirbasSearchResults() {
	uiState.demirbas.lastSearchUrl = null;
	clearDemirbasGrid();
	const countEl = document.getElementById("demirbas-count");
	if (countEl) countEl.textContent = "";
}

async function openBarcodeScannerPanel(section) {
	const panel = section?.querySelector(".barcode-scanner-panel");
	const preview = section?.querySelector(".barcode-scanner-preview");
	const button = section?.querySelector(".barcode-camera-btn");
	const input = section?.querySelector(".barcode-search-input");

	if (!panel || !preview || !input) return;

	panel.hidden = false;
	button?.classList.add("barcode-camera-btn--active");

	try {
		await startScanner(preview, (code) => {
			input.value = code;
			input.dispatchEvent(new Event("input", { bubbles: true }));
			hideBarcodeScannerPanel(section);
			input.focus();
		});
	} catch (err) {
		console.error("Barcode scanner baslatilamadi:", err);
		hideBarcodeScannerPanel(section);
	}
}

function ensureDemirbasView() {
	if (document.getElementById("demirbas-view")) return;
	document.getElementById("page-content").insertAdjacentHTML(
		"beforeend",
		`
<div id="demirbas-view">
    <div class="page-section" id="filter-section">
        <div class="section-header">
            <div class="section-header-left">
                <span class="material-icons section-icon">filter_list</span>
                <span class="section-title">Filtreler</span>
                <span class="filter-aktif-badge" hidden>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
                    </svg>
                    Filtre aktif
                </span>
            </div>
            <div class="section-header-right">
                <div class="mode-toggle-group">
                    <button class="mode-btn mode-btn--active" data-mode="filtre">
                        <span class="material-icons">tune</span>
                        Filtre Mod
                    </button>
                    <button class="mode-btn" data-mode="barkod">
                        <span class="material-icons">qr_code_scanner</span>
                        Barkod Mod
                    </button>
                </div>
                <button class="section-collapse-btn" title="Daralt/Geni&#351;let">
                    <span class="material-icons">expand_less</span>
                </button>
            </div>
        </div>
        <div class="section-body">
            <div class="filter-mode-content">
                <div class="cascading-dropdown-container">
                    <div class="cascading-dropdown-1 cascading-dropdown-item">
                        <div class="column-container">
                            <label for="departman">Departman</label>
                            <select name="" id="departman"><option selected value="">Departman se&ccedil;iniz</option></select>
                        </div>
                        <div class="column-container">
                            <label for="urun_grubu">&Uuml;r&uuml;n Grubu</label>
                            <select disabled name="u" id="urun_grubu"><option selected value="">&Uuml;r&uuml;n grubu se&ccedil;iniz</option></select>
                        </div>
                        <div class="column-container">
                            <label for="urun_alt_grubu">&Uuml;r&uuml;n Alt Grubu</label>
                            <select disabled name="u" id="urun_alt_grubu"><option selected value="">&Uuml;r&uuml;n alt grubu se&ccedil;iniz</option></select>
                        </div>
                        <div class="column-container">
                            <label for="urun_cinsi">&Uuml;r&uuml;n Cinsi</label>
                            <select disabled name="u" id="urun_cinsi"><option selected value="">&Uuml;r&uuml;n cinsi se&ccedil;iniz</option></select>
                        </div>
                        <div class="column-container">
                            <label for="marka">Marka</label>
                            <select disabled name="u" id="marka"><option selected value="">Marka se&ccedil;iniz</option></select>
                        </div>
                        <div class="column-container">
                            <label for="model">Model</label>
                            <select disabled name="u" id="model"><option selected value="">Model se&ccedil;iniz</option></select>
                        </div>
                    </div>
                    <div class="cascading-dropdown-2 cascading-dropdown-item">
                        <div class="column-container">
                            <label for="fatura_no">Fatura No</label>
                            <input type="text" id="fatura_no" placeholder="Fatura numaras&#305;..." maxlength="100" />
                        </div>
                        <div class="column-container">
                            <label for="tarih_baslangic">Sat&#305;n Alma (Ba&#351;lang&#305;&ccedil;)</label>
                            <input type="date" id="tarih_baslangic" />
                        </div>
                        <div class="column-container">
                            <label for="tarih_bitis">Sat&#305;n Alma (Biti&#351;)</label>
                            <input type="date" id="tarih_bitis" />
                        </div>
                        <div class="column-container">
                            <label for="urun_durumu_filter">&Uuml;r&uuml;n Durumu</label>
                            <select id="urun_durumu_filter"><option value="">T&uuml;m&uuml;</option></select>
                        </div>
                        <div class="column-container">
                            <label for="zimmet_durumu_filter">Zimmet Durumu</label>
                            <select id="zimmet_durumu_filter"><option value="">T&uuml;m&uuml;</option></select>
                        </div>
                        <div class="column-container">
                            <label for="zimmetlenen_kisi_filter">Zimmetlenen Ki&#351;i</label>
                            <select id="zimmetlenen_kisi_filter"><option value="">T&uuml;m&uuml;</option></select>
                        </div>
                    </div>
                    <div class="cascading-dropdown-3 cascading-dropdown-item">
                        <div class="column-container">
                            <label for="lokasyon_filter">Lokasyon</label>
                            <select id="lokasyon_filter"><option value="">T&uuml;m&uuml;</option></select>
                        </div>
                        <div class="column-container">
                            <label for="oda_filter">Oda</label>
                            <select id="oda_filter" disabled><option value="">T&uuml;m&uuml;</option></select>
                        </div>
                        <div class="column-container">
                            <label for="yer_filter">Yer</label>
                            <select id="yer_filter" disabled><option value="">T&uuml;m&uuml;</option></select>
                        </div>
                        <div class="column-container">
                            <label for="satin_alma_min_filter">Sat&#305;n Alma De&#287;eri Min</label>
                            <input type="text" inputmode="decimal" id="satin_alma_min_filter" placeholder="0,00 &#8378;" />
                        </div>
                        <div class="column-container">
                            <label for="satin_alma_max_filter">Sat&#305;n Alma De&#287;eri Max</label>
                            <input type="text" inputmode="decimal" id="satin_alma_max_filter" placeholder="0,00 &#8378;" />
                        </div>
                    </div>
                    <div class="filter-button-container">
                        <button class="filter-reset">Temizle</button>
                        <button class="search">Ara</button>
                    </div>
                </div>
            </div>
            <div class="barcode-mode-content" hidden>
                <div class="barcode-search-area">
                    <div class="barcode-input-wrapper">
                        <svg class="barcode-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                            <path d="M2 4h2v16H2zm3 0h1v16H5zm2 0h2v16H7zm3 0h1v16h-1zm2 0h2v16h-2zm3 0h1v16h-1zm2 0h3v16h-3z"/>
                        </svg>
                        <input type="text" class="barcode-search-input" placeholder="Barkodu okutun veya yaz&#305;n ve Enter'a bas&#305;n..." />
                        <button class="barcode-camera-btn" title="Kamera ile okut">
                            <span class="material-icons">photo_camera</span>
                        </button>
                    </div>
                    <div class="barcode-scanner-panel" hidden>
                        <div class="barcode-scanner-preview"></div>
                        <p class="barcode-scanner-help">Kamerayi barkoda yaklastirin. Okununca alan otomatik dolar.</p>
                    </div>
                    <p class="barcode-hint">Barkod ile aramak i&ccedil;in yukar&#305;ya barkodu okutun veya yaz&#305;p Enter'a bas&#305;n</p>
                </div>
            </div>
        </div>
    </div>
    <div class="page-section" id="table-section">
        <div class="section-header">
            <div class="section-header-left">
                <span class="section-title">Demirba&#351;lar</span>
                <span class="section-count" id="demirbas-count"></span>
            </div>
            <div class="section-header-right">
                <button class="barcode-cart-open-btn btn-header-action">
                    <span class="material-icons">shopping_basket</span>
                    Barkod Sepeti
                    <span class="barcode-cart-badge" hidden>0</span>
                </button>
                <button class="demirbas-ekle btn-header-action btn-header-action--primary">
                    <span class="material-icons">add</span>
                    Ekle
                </button>
            </div>
        </div>
        <div class="section-body">
            <div class="table-grid"></div>
        </div>
    </div>
</div>`,
	);
}

export function renderDemirbasPage() {
	ensureDemirbasView();

	const canEdit = ["admin", "kullanici"].includes(uiState.currentUser?.yetki);
	const canUseCart = canUseBarcodeCart(uiState.currentUser);
	const ekleBtn = document.querySelector(".demirbas-ekle");
	if (ekleBtn) ekleBtn.style.display = canEdit ? "" : "none";
	const cartBtn = document.querySelector(".barcode-cart-open-btn");
	if (cartBtn) cartBtn.style.display = canUseCart ? "" : "none";
	if (!canUseCart) {
		resetDemirbasBarcodeCart();
		closeBarcodeCartDialog();
	}

	initDemirbasFilters();
	initDemirbasGridEvents();

	initCreateDialog();
	initOverviewDialog();
	initEditDialog();
	initBarcodeCartDialog();
	updateBarcodeCartUi();

	if (!initialized) {
		initialized = true;
		initSectionInteractions();
	}

	// Sayfa ilk açıldığında boş tablo yerine tüm demirbaşlar listelenir.
	// Daha önce bir arama yapıldıysa (ör. filtreyle) o sonuç korunur.
	if (!uiState.demirbas.lastSearchUrl) {
		renderDemirbasGrid({ url: "/api/demirbas", paginationLimit: uiState.demirbas.paginationLimit || 10 });
	}
}

function initSectionInteractions() {
	const view = document.getElementById("demirbas-view");

	view.querySelectorAll(".section-collapse-btn").forEach((btn) => {
		btn.addEventListener("click", () => {
			btn.closest(".page-section").classList.toggle("collapsed");
		});
	});

	view.querySelectorAll(".mode-toggle-group").forEach((group) => {
		group.addEventListener("click", (e) => {
			const btn = e.target.closest(".mode-btn");
			if (!btn) return;
			setDemirbasMode(btn.dataset.mode);
		});
	});

	const filterSection = view.querySelector("#filter-section");
	const barcodeInput = filterSection?.querySelector(".barcode-search-input");
	const cameraButton = filterSection?.querySelector(".barcode-camera-btn");

	barcodeInput?.addEventListener("keydown", (event) => {
		if (event.key !== "Enter") return;
		event.preventDefault();

		const barcodeValue = barcodeInput.value.trim();
		if (!barcodeValue) return;

		uiState.demirbas.searchMode = "barkod";
		uiState.demirbas.barcodeQuery = barcodeValue;

		renderDemirbasGrid({
			url: buildBarcodeSearchUrl(barcodeValue),
			paginationLimit: uiState.demirbas.paginationLimit,
		});
	});

	cameraButton?.addEventListener("click", async () => {
		if (!filterSection) return;

		if (isScannerRunning()) {
			hideBarcodeScannerPanel(filterSection);
			return;
		}

		await openBarcodeScannerPanel(filterSection);
	});
}

function setDemirbasMode(mode = "filtre") {
	const section = document.querySelector("#filter-section");
	if (!section) return;

	const group = section.querySelector(".mode-toggle-group");
	const filterContent = section.querySelector(".filter-mode-content");
	const barcodeContent = section.querySelector(".barcode-mode-content");
	const badge = section.querySelector(".filter-aktif-badge");
	const currentMode = uiState.demirbas.searchMode || "filtre";

	if (currentMode === mode) {
		if (mode === "barkod") section.querySelector(".barcode-search-input")?.focus();
		return;
	}

	group?.querySelectorAll(".mode-btn").forEach((btn) => {
		btn.classList.toggle("mode-btn--active", btn.dataset.mode === mode);
	});

	if (mode === "barkod") {
		resetDemirbasFilters();
		resetBarcodeModeState(section);
		resetDemirbasSearchResults();
		uiState.demirbas.searchMode = "barkod";
	} else {
		resetBarcodeModeState(section);
		resetDemirbasFilters();
		resetDemirbasSearchResults();
		uiState.demirbas.searchMode = "filtre";
	}

	if (filterContent) filterContent.hidden = mode !== "filtre";
	if (barcodeContent) barcodeContent.hidden = mode !== "barkod";
	section.classList.remove("collapsed");
	if (badge) badge.hidden = true;
	if (mode === "barkod") {
		section.querySelector(".barcode-search-input")?.focus();
	}
}

export function resetDemirbasPage() {
	resetDemirbasFilters();
	resetBarcodeModeState(document.querySelector("#filter-section"));
	resetDemirbasSearchResults();
	setDemirbasMode("filtre");
	destroyDemirbasFilterAmountInputs();
	closeBarcodeCartDialog();
}

export function resetDemirbasSessionState() {
	resetDemirbasBarcodeCart();
}
